module.exports = __webpack_public_path__ + "img/矩形 30 拷贝 2.063390a3.png";